import { Badge, Button } from '@mantine/core';
import { Plus } from 'react-feather';

interface TopicPillProps {
  topicName?: string | null;
  onClick?: (e: React.MouseEvent) => void;
  size?: 'xs' | 'sm' | 'md';
  disabled?: boolean;
}

/**
 * Displays a topic pill or "Add Topic" button
 * - Assigned topic: Dark green pill (#2D4739) with white text
 * - No topic: Dashed border button with gray text
 */
export function TopicPill({ topicName, onClick, size = 'sm', disabled = false }: TopicPillProps) {
  if (topicName) {
    return (
      <Badge
        size={size}
        variant="filled"
        color="medleyGreen"
        style={{ cursor: disabled ? 'default' : 'pointer' }}
        onClick={disabled ? undefined : onClick}
      >
        {topicName}
      </Badge>
    );
  }

  return (
    <Button
      variant="outline"
      size="xs"
      leftSection={<Plus size={12} />}
      onClick={onClick}
      disabled={disabled}
      styles={{
        root: {
          borderStyle: 'dashed',
          borderColor: 'var(--mantine-color-gray-4)',
          color: 'var(--mantine-color-gray-6)',
          '&:hover': {
            backgroundColor: 'var(--mantine-color-gray-0)',
            borderColor: 'var(--mantine-color-gray-5)',
          },
        },
      }}
    >
      Add Topic
    </Button>
  );
}

export default TopicPill;
